var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.553,
    y: 15.6703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 19.553 15.6703)",
    fill: "#A3AAB3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.053,
    y: 15.6703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 15.053 15.6703)",
    fill: "#A3AAB3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.553,
    y: 15.6703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 10.553 15.6703)",
    fill: "#A3AAB3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.55298,
    y: 15.6703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-90 3.55298 15.6703)",
    fill: "#A3AAB3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.553,
    y: 11.1703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 19.553 11.1703)",
    fill: "#A3AAB3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.053,
    y: 11.1703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 15.053 11.1703)",
    fill: "#A3AAB3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.553,
    y: 11.1703,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 10.553 11.1703)",
    fill: "#A3AAB3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.55005,
    y: 0.189819,
    width: 1.80762,
    height: 4.95087,
    fill: "#A3AAB3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4924,
    y: 0.189819,
    width: 1.80762,
    height: 4.95087,
    fill: "#A3AAB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.106 2.78625L1 2.78625L1 22.85L22.106 22.85L22.106 2.78625Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.c095a66bdbcbe44dd9aaa9ffff935c2b.svg";
export { ForwardRef as ReactComponent };